import React, { Component } from 'react';
import Header from '../layout/Header';

export default class Home extends Component {
    render() {
        return (
            <>
            <Header />
            </>
        );
    }
}